// extracted by mini-css-extract-plugin
export default {"groupControls":"styles_groupControls__KCOu6"};